
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 22 13","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M11 12.5c-.422 0-.797-.14-1.078-.422l-9-9a1.445 1.445 0 010-2.11 1.445 1.445 0 012.11 0L11 8.892 18.922.969a1.445 1.445 0 012.11 0c.609.562.609 1.547 0 2.11l-9 9A1.454 1.454 0 0111 12.5z","fill":"#008440"}})])
          )
        }
      }
    